/*
 * @Author: hzm
 * @Date: 2024-05-17 16:42:02
 * @Description:
 */
import http from '@/utils/request';

// /coupon/userCouponList

export function getUserCouponList(query) {
  return http.request({
    url: '/mro/coupon/userCouponList',
    method: 'get',
    params: query,
  });
}

// 即将过期 /coupon/userExpiringSoonCoupon
export function getUserExpiringSoonCoupon(query) {
  return http.request({
    url: '/mro/coupon/userExpiringSoonCoupon',
    method: 'get',
    params: query,
  });
}

// /coupon/couponCount
export function getCouponCount(query) {
  return http.request({
    url: '/mro/coupon/couponCount',
    method: 'get',
    params: query,
  });
}
